import { Icon, IconProps } from '~/components/Icon/Icon';

export type Dog2DProps = IconProps;
export const Dog2D = (props: Dog2DProps) => (
  <Icon
    width="35"
    height="34"
    viewBox="0 0 35 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M0.15625 0H34.1563V34H0.15625V0Z" fill="white" fillOpacity="0.2" />
    <circle cx="10.8328" cy="9.94256" r="2.85918" fill="#20312E" />
    <circle cx="23.4798" cy="9.94256" r="2.85918" fill="#20312E" />
    <ellipse cx="10.8332" cy="9.94244" rx="1.48216" ry="1.48216" fill="#B97D60" />
    <ellipse cx="23.4797" cy="9.94244" rx="1.48216" ry="1.48216" fill="#B97D60" />
    <mask
      id="mask0_7759_5907"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="7"
      width="26"
      height="20">
      <path
        d="M5.07794 19.0923C5.53543 12.7593 10.8067 7.855 17.1562 7.855C23.5057 7.855 28.7771 12.7593 29.2346 19.0923L29.7998 26.9168H4.5127L5.07794 19.0923Z"
        fill="#20312E"
      />
    </mask>
    <g mask="url(#mask0_7759_5907)">
      <path
        d="M5.07794 19.0923C5.53543 12.7593 10.8067 7.855 17.1562 7.855C23.5057 7.855 28.7771 12.7593 29.2346 19.0923L29.7998 26.9168H4.5127L5.07794 19.0923Z"
        fill="#20312E"
      />
      <path
        d="M9.52921 18.8164C6.01427 24.4358 2.47233 31.5256 6.97753 31.5256H27.3351C31.8403 31.5256 28.2984 24.4358 24.7835 18.8164C22.8845 15.7805 18.4817 16.3351 17.1563 19.6617C15.8309 16.3351 11.4282 15.7805 9.52921 18.8164Z"
        fill="#B97D60"
      />
      <rect x="13.479" y="17.4151" width="1.35147" height="1.35147" fill="#522D2B" />
      <rect x="19.4199" y="17.4151" width="1.35147" height="1.35147" fill="#522D2B" />
      <path
        d="M20.4266 20.7674C20.4266 22.5736 18.9624 23.6935 17.1562 23.6935C15.35 23.6935 13.8857 22.5736 13.8857 20.7674C13.8857 18.9612 15.3501 17.3248 17.1563 17.3248C18.9625 17.3248 20.4266 18.9612 20.4266 20.7674Z"
        fill="#FFFEEC"
      />
      <path d="M17.1564 19.2077V20.4987L16.0591 21.596" stroke="#71201F" strokeWidth="0.653846" />
      <path d="M17.1566 19.2077V20.4987L18.2539 21.596" stroke="#71201F" strokeWidth="0.653846" />
      <path d="M17.1568 19.7348L15.8897 17.7983L18.4238 17.7983L17.1568 19.7348Z" fill="#20312E" />
      <ellipse
        cx="19.523"
        cy="15.7865"
        rx="1.2802"
        ry="1.04352"
        transform="rotate(-30 19.523 15.7865)"
        fill="#B97D60"
      />
      <ellipse
        cx="1.2802"
        cy="1.04352"
        rx="1.2802"
        ry="1.04352"
        transform="matrix(-0.866025 -0.5 -0.5 0.866025 16.4199 15.5229)"
        fill="#B97D60"
      />
    </g>
  </Icon>
);
